import { render, staticRenderFns } from "./Familia.vue?vue&type=template&id=1e1d4bde&scoped=true&"
import script from "./Familia.vue?vue&type=script&lang=js&"
export * from "./Familia.vue?vue&type=script&lang=js&"
import style0 from "./Familia.vue?vue&type=style&index=0&id=1e1d4bde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1d4bde",
  null
  
)

export default component.exports